import { Box, BoxProps } from '@mui/material';
import React, { PropsWithChildren } from 'react';

export const SidenavIcon = ({
  children,
  sx,
  className,
  component = 'span',
  ...props
}: PropsWithChildren<BoxProps & { component?: React.ElementType } & Record<string, any>>) => {
  return (
    <Box
      component={component}
      className={className}
      sx={{
        display: component === 'img' ? 'inline-block' : 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        width: '36px',
        height: '36px',
        lineHeight: '36px',
        marginRight: '20px',
        flexShrink: 0,
        borderRadius: '50%',
        transition: 'all 0.1s',
        '& svg': {
          marginRight: 0,
        },
        ...sx,
      }}
      {...(props as any)}
    >
      {children}
    </Box>
  );
};
